import * as queryString from "query-string";
import { DashboardContainerProps } from "../containers/dashboard.container";


export function siteDetailMapQueryStringToProps(props: DashboardContainerProps): any {
    /*let returnProps = {
        activePlot: props.activePlot
    }

    if (returnProps.activePlot == undefined) {
        // get activePlot using queryString parameter

        // need id from query
        let queryParams =
            queryString.parse(props.location.search);

        if (queryParams.activePlotId) {

            // look for activePlot and populate activePlot
            if (props.data) {
                returnProps.activePlot =
                    props.data.find((plot) => {
                        return plot.id == queryParams.activePlotId
                    });
            }
        }
    }

    return returnProps;*/
}

export function siteDetailShouldRerouteHome(
    props: DashboardContainerProps,
    prevProps: DashboardContainerProps) {

        return false;
        
    //console.log('site detail should reroute home?');

    //let queryParams =
    //    queryString.parse(props.location.search);

    // reroute if we are haven't been provided the means to get the data we need to render.
    //if (!props.activePlot &&
    //     !queryParams.activePlotId) {

    //     return true;
    //}
    //// reroute if we have been provided with a query 
    //else {
    //    return false;
    //}


    //if (prevProps.activePlot == undefined &&
    //    props.activePlot == undefined &&
    //    (prevProps.loading == true && props.loading == false)) {
    //    return true;
    //}
    //else {
    //    return false;
    //}
}

export function siteDetailEventMapQueryStringToProps(props: DashboardContainerProps): any {
    return props;
}

export function siteDetailEventShouldRerouteHome(
    props: DashboardContainerProps,
    prevProps: DashboardContainerProps) {

    //console.log('should reroute home?');

    /*if (prevProps.map.plot == undefined &&
        props.map.plot == undefined &&
        (prevProps.loading == true && props.loading == false)) {
        return true;
    }
    else {
        return false;
    }*/

    return false;
}

export function mapSummaryQueryStringToProps(props: DashboardContainerProps): any {
    let returnProps = {
        queryDateStart: props.queryDateStart,
        queryDateEnd: props.queryDateEnd,
        queryCommunityGroupId: props.queryCommunityGroupId,
        queryMapType: props.queryMapType,
        queryDefaultGraph: props.queryDefaultGraph || "total"
    }

    let queryParams =
        queryString.parse(props.location.search);

    if (queryParams.dateStart) {
        returnProps.queryDateStart =
            queryParams.dateStart;
    }

    if (queryParams.dateEnd) {
        returnProps.queryDateEnd =
            queryParams.dateEnd;
    }

    if (queryParams.communityGroupId) {
        returnProps.queryCommunityGroupId =
            queryParams.communityGroupId;
    }

    if (queryParams.mapType) {
        returnProps.queryMapType =
            queryParams.mapType;
    }

    if (queryParams.graph) {
        returnProps.queryDefaultGraph =
            queryParams.graph;
    }

    return returnProps;
}

export function mapMapQueryStringToProps(props: DashboardContainerProps): any {
    let returnProps = {
        queryDateStart: props.queryDateStart,
        queryDateEnd: props.queryDateEnd,
        queryCommunityGroupId: props.queryCommunityGroupId,
        queryMapType: props.queryMapType
    }

    let queryParams =
        queryString.parse(props.location.search);

    if (queryParams.dateStart) {
        returnProps.queryDateStart =
            queryParams.dateStart;
    }

    if (queryParams.dateEnd) {
        returnProps.queryDateEnd =
            queryParams.dateEnd;
    }

    if (queryParams.communityGroupId) {
        returnProps.queryCommunityGroupId =
            queryParams.communityGroupId;
    }

    if (queryParams.mapType) {
        returnProps.queryMapType =
            queryParams.mapType;
    }

    return returnProps;
}

export function changePasswordMapQueryStringToProps(props: DashboardContainerProps): any {
    let returnProps = {
        queryChangePasswordToken: props.queryChangePasswordToken
    }

    if (returnProps.queryChangePasswordToken == undefined) {
        
        let queryParams =
            queryString.parse(props.location.search);

        if (queryParams.changePasswordToken) {

            returnProps.queryChangePasswordToken = queryParams.changePasswordToken
        }
    }

    return returnProps;
}

export function activateAccountMapQueryStringToProps(props: DashboardContainerProps): any {
    let returnProps = {
        queryActivateAccountToken: props.queryActivateAccountToken
    }

    if (returnProps.queryActivateAccountToken == undefined) {
        
        let queryParams =
            queryString.parse(props.location.search);

        if (queryParams.activateAccountToken) {

            returnProps.queryActivateAccountToken = queryParams.activateAccountToken
        }
    }

    return returnProps;
}